export const dateFormatShort = 'DD/MM/YYYY'
export const dateFormatLong = 'DD/MM/YYYY HH:mm:ss'
export const dateFormatMedium = 'DD/MM/YYYY HH:mm'
export const dateFormatSecond = 'HH:mm'

export const weekday = [
  '',
  'Thứ hai',
  'Thứ ba',
  'Thứ tư',
  'Thứ năm',
  'Thứ sáu',
  'Thứ bảy',
  'Chủ nhật',
]
